// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnterLink__input-cc34d3 {
  width: 300px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-4);
  color: var(--base-110);
  margin-inline-start: 6px;
}
.EnterLink__input-cc34d3::placeholder {
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingMenu/Content/EnterLink/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qCAAA;EACA,sBAAA;EACA,wBAAA;AACF;AACE;EACE,qBAAA;AACJ","sourcesContent":[".input {\n  width: 300px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-4);\n  color: var(--base-110);\n  margin-inline-start: 6px;\n\n  &::placeholder {\n    color: var(--base-80);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `EnterLink__input-cc34d3`
};
module.exports = ___CSS_LOADER_EXPORT___;
